import { useEffect, useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import API from "../api/api";
import ProductCard from "../components/ProductCard";
import "./ProductList.css";

export default function ProductList() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  // --- Filtering States
  const [styleFilter, setStyleFilter] = useState("");
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const searchQuery = queryParams.get("search")?.toLowerCase() || "";

  useEffect(() => {
    setLoading(true);
    API.get("/products/") // Ensure leading slash for production
      .then(res => {
        const data = res.data.results || res.data;
        setProducts(data);
      })
      .finally(() => setLoading(false));
  }, []);

  const styleOptions = useMemo(
    () => ["", ...new Set(products.map(p => p.style).filter(Boolean))],
    [products]
  );

  const filteredProducts = useMemo(() => {
    return products.filter(p => {
      const bySearch =
        (!searchQuery ||
          p.name?.toLowerCase().includes(searchQuery) ||
          p.brand?.toLowerCase().includes(searchQuery));
      const byStyle = !styleFilter || p.style === styleFilter;
      const price = parseFloat(p.price) || 0; // safer number parsing
      const minOK = !minPrice || price >= parseFloat(minPrice);
      const maxOK = !maxPrice || price <= parseFloat(maxPrice);
      return bySearch && byStyle && minOK && maxOK;
    });
  }, [products, searchQuery, styleFilter, minPrice, maxPrice]);

  return (
    <div className="page-container">
      {/* FILTER BAR */}
      <div className="filter-bar">
        <select
          value={styleFilter}
          onChange={e => setStyleFilter(e.target.value)}
          className="filter-select"
        >
          <option value="">All Styles</option>
          {styleOptions.filter(Boolean).map(style => (
            <option key={style} value={style}>
              {style}
            </option>
          ))}
        </select>
        <input
          type="number"
          className="filter-price"
          min={0}
          placeholder="Min price"
          value={minPrice}
          onChange={e => setMinPrice(e.target.value)}
        />
        <span className="filter-dash">-</span>
        <input
          type="number"
          className="filter-price"
          min={0}
          placeholder="Max price"
          value={maxPrice}
          onChange={e => setMaxPrice(e.target.value)}
        />
        {searchQuery && (
          <div className="search-results-header" style={{ marginLeft: "auto" }}>
            <h2 className="search-label">Results for "{searchQuery}"</h2>
            <p className="search-count">{filteredProducts.length} items found</p>
          </div>
        )}
      </div>

      {loading ? (
        <div className="loader">Loading Collections...</div>
      ) : (
        <>
          <div className="product-grid">
            {filteredProducts.length === 0 && !loading && (
              <div className="empty-state">
                <p>No products found matching your filters.</p>
              </div>
            )}
            {filteredProducts.map(p => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        </>
      )}
    </div>
  );
}